import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { BzObjType } from '../Enums/BzObjType.enum';
import { EMode } from '../Enums/EMode.enum';
import { ProjectHoursBillingBy } from '../Enums/ProjectHoursBillingBy.enum';
import { ProjectHoursBillingType } from '../Enums/ProjectHoursBillingType.enum';

export class BillProjectHoursRequestSettings<T extends EMode = EMode.entity> {
  /** Alias: billingType */
  billingType?: ProjectHoursBillingType;
  /** Alias: billingBy */
  billingBy?: ProjectHoursBillingBy;
  /** Alias: positionAddComment */
  positionAddComment?: any;
  /** Alias: positionAddArticleDescription */
  positionAddArticleDescription?: any;
  /** Alias: customerCodes */
  customerCodes?: any[];
  /** Alias: orderConfirmationCodes */
  orderConfirmationCodes?: any[];
  /** Alias: articleCode */
  articleCode?: any;
  /** Alias: converAllPositionsFromOrderConformation */
  converAllPositionsFromOrderConformation?: any;
  /** Alias: billingInDays */
  billingInDays?: any;
  /** Alias: billFurtherServices */
  billFurtherServices?: any;
  /** Alias: documentDate */
  documentDate?: string;
  /** Alias: onlyCompletedTickets */
  onlyCompletedTickets?: any;
  /** Alias: headerShowOrderReference */
  headerShowOrderReference?: any;
  /** Alias: headerShowProjectReference */
  headerShowProjectReference?: any;
  /** Alias: headerShowTimespan */
  headerShowTimespan?: any;
  /** Alias: bzObjType */
  bzObjType?: BzObjType;
  /** Alias: positionShowOrderReference */
  positionShowOrderReference?: boolean;
  /** Alias: dryRun */
  dryRun?: boolean;
  /** Alias: dryRunSkip */
  dryRunSkip?: number;
  /** Alias: positionAddUser */
  positionAddUser?: boolean;
  /** Alias: positionAddDate */
  positionAddDate?: boolean;
  /** Alias: positionAddPositionNumber */
  positionAddPositionNumber?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<BillProjectHoursRequestSettings> = {
  billingType: {
    alias: 'billingType',
  },
  billingBy: {
    alias: 'billingBy',
  },
  positionAddComment: {
    alias: 'positionAddComment',
  },
  positionAddArticleDescription: {
    alias: 'positionAddArticleDescription',
  },
  customerCodes: {
    alias: 'customerCodes',
  },
  orderConfirmationCodes: {
    alias: 'orderConfirmationCodes',
  },
  articleCode: {
    alias: 'articleCode',
  },
  converAllPositionsFromOrderConformation: {
    alias: 'converAllPositionsFromOrderConformation',
  },
  billingInDays: {
    alias: 'billingInDays',
  },
  billFurtherServices: {
    alias: 'billFurtherServices',
  },
  documentDate: {
    alias: 'documentDate',
  },
  onlyCompletedTickets: {
    alias: 'onlyCompletedTickets',
  },
  headerShowOrderReference: {
    alias: 'headerShowOrderReference',
  },
  headerShowProjectReference: {
    alias: 'headerShowProjectReference',
  },
  headerShowTimespan: {
    alias: 'headerShowTimespan',
  },
  bzObjType: {
    alias: 'bzObjType',
  },
  positionShowOrderReference: {
    alias: 'positionShowOrderReference',
  },
  dryRun: {
    alias: 'dryRun',
  },
  dryRunSkip: {
    alias: 'dryRunSkip',
  },
  positionAddUser: {
    alias: 'positionAddUser',
  },
  positionAddDate: {
    alias: 'positionAddDate',
  },
  positionAddPositionNumber: {
    alias: 'positionAddPositionNumber',
  },
  __typename: {
    alias: '__typename',
  },
};

export const billProjectHoursRequestSettingsEntityDefinition: EntitiyDefinition<BillProjectHoursRequestSettings> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'BillProjectHoursRequestSettings',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
